import {
  Button,
  Container,
  Distribute,
  Spacer,
  Text,
  TextInput,
} from '@loomhq/lens';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import emptyIcon from 'img/illustrations/shared-library.svg';

import * as validate from '../../../../../../shared/validate';
import SalesforceEmailsList from '../salesforce-email-list';
import { ENTER } from '../../../../constants/keyCodes';
import { createShareVideoAlias } from '../../../../creators/shareVideo';

import styles from './styles.module.less';

const SalesforceAddEmail = ({ deleteLinkHandler }) => {
  const dispatch = useDispatch();

  const [addBtnDisabled, setAddBtnDisabled] = useState(true);
  const [showEmailError, setShowEmailError] = useState(false);

  const { video, shareVideoAliases } = useSelector(state => state.share_video);
  const inputRef = useRef();

  const checkEmailIsValid = e => {
    const { value } = e.target;

    if (validate.email(value)) {
      setShowEmailError(false);
      setAddBtnDisabled(false);
    } else {
      setShowEmailError(value?.length !== 0);
      setAddBtnDisabled(true);
    }
  };

  const addEmailToList = () => {
    const email = inputRef.current?.value;
    const emails = shareVideoAliases.map(e => e.email);

    if (emails.includes(email) || !validate.email(email)) {
      return;
    }

    if (email) {
      dispatch(createShareVideoAlias(video.id, email));

      inputRef.current.value = '';
      setAddBtnDisabled(true);
    }
  };

  return (
    <Container className={styles.sfdcModalContainer}>
      <Text>
        {shareVideoAliases.length > 0
          ? 'Each email address will be given a special link to track the recipient’s activity.'
          : 'Add emails to generate custom links and track how each contact engages with your video.'}
      </Text>
      <Spacer bottom="medium" />
      <Text fontWeight="bold">Email</Text>
      <Spacer bottom="xsmall" />
      <Distribute gap="small">
        <TextInput
          ref={inputRef}
          type="email"
          placeholder="Enter lead email address..."
          className={styles.emailInput}
          onChange={checkEmailIsValid}
          onKeyDown={e => e.keyCode === ENTER && addEmailToList()}
          hasError={showEmailError}
        />
        <Button
          variant="neutral"
          isDisabled={addBtnDisabled}
          onClick={() => !addBtnDisabled && addEmailToList()}
        >
          Add
        </Button>
      </Distribute>
      {showEmailError && (
        <Text color="danger" className="mt:xsmall">
          Please enter a valid email.
        </Text>
      )}
      <Spacer top="medium" />
      {shareVideoAliases.length > 0 ? (
        <SalesforceEmailsList
          fromModal={true}
          deleteLinkHandler={deleteLinkHandler.bind(this)}
        />
      ) : (
        <Distribute direction="column" alignment="center" className="mt:xlarge">
          <img src={emptyIcon} className={styles.emptyIcon} />
          <Spacer top="large" />
          <Text variant="title">No emails have been added yet</Text>
          <Spacer top="small" />
          <Text color="bodyDimmed" alignment="center">
            Add an email to track how a contact engages with your Loom video
            directly in Salesforce.
          </Text>
        </Distribute>
      )}
    </Container>
  );
};

export default SalesforceAddEmail;
